import React from 'react';
import classNames from 'classnames';

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  disabled: boolean;
  ariaLabel: string;
}

export default function IncrementButton({
  children,
  onClick,
  disabled,
  ariaLabel
}: Props) {
  return (
    <button
      type="button"
      aria-disabled={disabled}
      onClick={onClick}
      className={classNames(
        'bg-white border border-neutral-200 hover:border-neutral-900 rounded-full h-[28px] w-[28px] flex items-center justify-center',
        {
          'opacity-30 pointer-events-none': disabled
        }
      )}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
}
